// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vertical-icon[data-v-16196914] {\n  color: var(--bs-primary);\n}\n.text-danger[data-v-16196914]:hover {\n  color: #b82c44 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
